// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CostCategoryModalQueryVariables = Types.Exact<{
  filter: Types.CostCodeFilter;
}>;


export type CostCategoryModalQuery = { __typename?: 'Query', costCodes: Array<{ __typename?: 'CostCode', id: string, number: string, name: string, costClassification: { __typename?: 'CostClassificationTypeDetail', code: Types.CostClassificationType }, costSubClassification?: { __typename?: 'CostSubClassificationTypeDetail', code: Types.CostSubClassificationType } | null | undefined }> };

export type CostCategoryModal_CostCodeFragment = { __typename?: 'CostCode', id: string, number: string, name: string, costClassification: { __typename?: 'CostClassificationTypeDetail', code: Types.CostClassificationType }, costSubClassification?: { __typename?: 'CostSubClassificationTypeDetail', code: Types.CostSubClassificationType } | null | undefined };

export const CostCategoryModal_CostCodeFragmentDoc = gql`
    fragment CostCategoryModal_CostCode on CostCode {
  id
  number
  name
  costClassification {
    code
  }
  costSubClassification {
    code
  }
}
    `;
export const CostCategoryModalDocument = gql`
    query CostCategoryModal($filter: CostCodeFilter!) {
  costCodes(filter: $filter) {
    ...CostCategoryModal_CostCode
  }
}
    ${CostCategoryModal_CostCodeFragmentDoc}`;

/**
 * __useCostCategoryModalQuery__
 *
 * To run a query within a React component, call `useCostCategoryModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostCategoryModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostCategoryModalQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCostCategoryModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CostCategoryModalQuery, CostCategoryModalQueryVariables> & ({ variables: CostCategoryModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CostCategoryModalQuery, CostCategoryModalQueryVariables>(CostCategoryModalDocument, options);
      }
export function useCostCategoryModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CostCategoryModalQuery, CostCategoryModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CostCategoryModalQuery, CostCategoryModalQueryVariables>(CostCategoryModalDocument, options);
        }
// @ts-ignore
export function useCostCategoryModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CostCategoryModalQuery, CostCategoryModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CostCategoryModalQuery, CostCategoryModalQueryVariables>;
export function useCostCategoryModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CostCategoryModalQuery, CostCategoryModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CostCategoryModalQuery | undefined, CostCategoryModalQueryVariables>;
export function useCostCategoryModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CostCategoryModalQuery, CostCategoryModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CostCategoryModalQuery, CostCategoryModalQueryVariables>(CostCategoryModalDocument, options);
        }
export type CostCategoryModalQueryHookResult = ReturnType<typeof useCostCategoryModalQuery>;
export type CostCategoryModalLazyQueryHookResult = ReturnType<typeof useCostCategoryModalLazyQuery>;
export type CostCategoryModalSuspenseQueryHookResult = ReturnType<typeof useCostCategoryModalSuspenseQuery>;
export type CostCategoryModalQueryResult = ApolloReactCommon.QueryResult<CostCategoryModalQuery, CostCategoryModalQueryVariables>;